import { Component, Input } from '@angular/core';
import { Report } from '../../../../models/report.model';

@Component({
  selector: 'app-valeur-estimee-sans-plus-ou-moins-values',
  templateUrl: './valeur-estimee-sans-plus-ou-moins-values.component.html',
  styleUrls: ['./valeur-estimee-sans-plus-ou-moins-values.component.scss'],
})
export class ValeurEstimeeSansPlusOuMoinsValuesComponent {
  @Input() appraisal!: Report.Appraisal;
}
